<template>
  <div v-if="!getDeviceType()" class="loginPage">
    <div class="loginColumn">
      <img class="loginLogo" src="@/assets/searchLogo.svg" />
      <img class="loginImage" src="@/assets/loginIcon.png" />
      <img class="loginLogoText" src="@/assets/CourseLnk.png" />
    </div>
    <div class="loginColumn">
      <form @submit.prevent="addReferallCode" class="loginForm">
        <p class="loginTitle">Did someone refer you?</p>
        <p>
          *Enter the code of the student who referred you to get entered into a
          draw to win airpods!
        </p>

        <div class="signUpNames">
          <div
            class="user-input-wrp user-input-wrpSmall"
            style="margin-right: 10px"
          >
            <input
              v-model="referralCode"
              type="text"
              name="name"
              required
              class="inputText"
            />
            <p style="color: red">{{ this.feedback }}</p>
          </div>
        </div>
        <div class="loginSignupDivider"></div>
        <div class="signupBox">
          <button class="joinButtonSmall toSignup" @click="addReferallCode">
            Continue
          </button>
          <button class="joinButtonSmall toSignup" @click="showNextView">
            Skip
          </button>
        </div>
      </form>
    </div>
    <div class="bottomNav">
      <p class="landingButtonHoverless">CourseLnk © 2021</p>
      <router-link
        class="landingButton"
        :to="{
          name: 'Landingpage',
        }"
        >About</router-link
      >
      <router-link
        class="landingButton"
        :to="{ name: 'Terms' }"
        target="_blank"
      >
        Terms and Conditions
      </router-link>
      <router-link
        class="landingButton"
        :to="{ name: 'Privacy' }"
        target="_blank"
      >
        Privacy Policy
      </router-link>
      <router-link class="landingButton" :to="{ name: 'Ambassadors' }">
        Join the team
      </router-link>
    </div>
    <div class="bottomNavSmall">
      <p class="landingButtonHoverless">CourseLnk © 2021</p>
      <div class="bottomColumn">
        <router-link
          class="landingButton"
          :to="{
            name: 'Landingpage',
          }"
          >About</router-link
        >
        <router-link class="landingButton" :to="{ name: 'Ambassadors' }">
          Join the team
        </router-link>
      </div>
      <div class="bottomColumn">
        <router-link
          class="landingButton"
          :to="{ name: 'Terms' }"
          target="_blank"
        >
          Terms and Conditions
        </router-link>
        <router-link
          class="landingButton"
          :to="{ name: 'Privacy' }"
          target="_blank"
        >
          Privacy Policy
        </router-link>
      </div>
    </div>
  </div>
  <div v-else class="loginPage">
    <div class="loginColumn"></div>
    <div class="loginColumn">
      <div @submit.prevent="login" class="loginForm formOnPhone">
        <img class="loginLogo" src="@/assets/searchLogo.svg" />
        <img class="loginLogoTextPhone" src="@/assets/CourseLnk.png" />
        <p class="loginTitle">Welcome to your online campus!</p>
        <form
          method="get"
          action="https://apps.apple.com/ca/app/courselnk/id1545799969"
        >
          <img src="../../assets/downloadOnAppStore.png" />
        </form>
        <p class="phoneText">Or access courselnk.com on a computer</p>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "@/firebase";
import db from "@/db";

export default {
  data() {
    return {
      referralCode: "",
      feedback: "",
      alreadyEntered: false,
    };
  },

  mounted() {
    this.getIOS();
  },

  methods: {
    getDeviceType() {
      const ua = navigator.userAgent;
      if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return true;
      }
      if (
        /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
          ua
        )
      ) {
        return true;
      }
      return false;
    },
    iOS() {
      return (
        [
          "iPad Simulator",
          "iPhone Simulator",
          "iPod Simulator",
          "iPad",
          "iPhone",
          "iPod",
        ].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes("Mac") && "ontouchend" in document)
      );
    },
    getIOS() {
      if (this.iOS()) {
        window.location.replace("https://courselnk.page.link");
      }
    },
    showNextView() {
      // **** PUSH TO NEXT VIEW ****
    },

    addReferallCode() {
      if (this.referralCode.length < 3) {
        this.feedback = "You must enter a code or click 'Skip'";
        return;
      }

      firebase
        .auth()
        .fetchSignInMethodsForEmail(this.referralCode)
        .then((info) => {
          if (info.length > 0) {
            if (!this.alreadyEntered) {
              this.alreadyEntered = true;
              var getUserFromEmail = firebase
                .functions()
                .httpsCallable("getUserFromEmail");
              getUserFromEmail(this.referralCode).then((data) => {
                db.collection("users")
                  .doc(data.data.uid)
                  .update({
                    numReferrrals: firebase.firestore.FieldValue.increment(1),
                  });

                db.collection("users")
                  .doc(firebase.auth().currentUser.uid)
                  .update({
                    numReferrrals: firebase.firestore.FieldValue.increment(1),
                  });
              });
            }

            this.feedback = "";
            this.showNextView();
          } else {
            this.feedback = "No account exists with your entered referral code";
          }
        })
        .catch((error) => {
          this.feedback = error.message;
        });
    },
  },
};
</script>

<style scoped src="@/styles/components/auth/Login.css"></style>
